// import {
//   Card,
//   CardBody,
//   Input,
//   Table,
//   TableCell,
//   TableContainer,
//   TableHeader,
//   Button,
// } from "@windmill/react-ui";
// import { useState, useEffect, useContext } from "react";
// import { Tabs, Tab } from "@mui/material";
// import { FiRefreshCcw } from "react-icons/fi";
// import ExportDataXlsx from "components/common/ExportDataXlsx";
// import DataWrapper from "./DataWrapper";
// import NotFound from "components/table/NotFound";
// import PageTitle from "components/Typography/PageTitle";
// import useFilter from "hooks/useFilter";
// import VehicleAllotServices from "services/VehicleAllotServices";
// import MainDrawer from "components/drawer/MainDrawer";
// import DeleteModal from "components/modal/DeleteModal";
// import { SidebarContext } from "context/SidebarContext";

// import VehicleAllotTable from "components/driver/VehicleAllotTable";
// import VehicleAllotDrawer from "components/drawer/VehicleAllotDrawer";
// import LabelArea from "components/form/LabelArea";
// import InputSearchDate from "components/form/InputSearchDate";
// import sidebar from "routes/sidebar";
// import Somethingwentwrong from "pages/Somethingwentwrong";
// import { useLocation } from "react-router-dom";

// const VehicleAllot = () => {
//   const location = useLocation();
//   const adminInfo = localStorage.getItem("adminInfo")
//     ? JSON.parse(localStorage.getItem("adminInfo"))
//     : null;
//   const [drivers, setDrivers] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [tab, setTab] = useState(0); // Tab state
//   const [error, setError] = useState(false);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const { setIsUpdate, isUpdate } = useContext(SidebarContext);
//   const [status, setStatus] = useState(false);
//   const [exportingData, setExportingData] = useState([]);

//   // const { adminInfo } = state;
//   const {
//     vehicleAllotRef,
//     dataTable,
//     serviceData,
//     handleSubmitVehicleAllot,
//     currentPage,
//   } = useFilter(drivers, itemsPerPage);

//   useEffect(() => {
//     if (serviceData.length !== 0) {
//       setItemsPerPage(serviceData.length);
//     }
//   }, [serviceData]);
//   const [searchstartDate, setSearchStartDate] = useState(null);
//   const [searchendDate, setSearchEndDate] = useState(null);
//   const formatDate = (date) => {
//     if (!date) return null;
//     const d = new Date(date);
//     const day = String(d.getDate()).padStart(2, "0");
//     const month = String(d.getMonth() + 1).padStart(2, "0");
//     const year = d.getFullYear();
//     return `${day}-${month}-${year}`;
//   };
//   const parseDDMMYYYY = (value) => {
//     if (!value) return null;
//     const [d, m, y] = value.split("-");
//     const date = new Date(`${y}-${m}-${d}`);
//     return isNaN(date.getTime()) ? null : date;
//   };

//   const formattedDates = {
//     start_date: formatDate(searchstartDate),
//     end_date: formatDate(searchendDate),
//   };

//   useEffect(() => {
//     const params = new URLSearchParams(location.search);
//     const startStr = params.get("start");
//     const endStr = params.get("end");

//     const startDate = parseDDMMYYYY(startStr);
//     const endDate = parseDDMMYYYY(endStr);

//     let needsRefresh = false;

//     if (startDate) {
//       setSearchStartDate((prev) =>
//         prev?.getTime() === startDate.getTime() ? prev : startDate
//       );
//       needsRefresh = true;
//     }

//     if (endDate) {
//       setSearchEndDate((prev) =>
//         prev?.getTime() === endDate.getTime() ? prev : endDate
//       );
//       needsRefresh = true;
//     }

//     if (needsRefresh) {
//       setIsUpdate(true);
//     }
//   }, [location.search]);

//   // Fetch data based on selected tab
//   useEffect(() => {
//     const fetchDrivers = async () => {
//       setLoading(true);
//       try {
//         const response = await VehicleAllotServices.getVehicleAllotList({
//           id_employee: adminInfo.id,
//           type: tab + 1,
//           from: formattedDates.start_date,
//           to: formattedDates.end_date,
//            is_seller: adminInfo?.id_profile === 3 ? true : false,
//         });
//         // console.log("vehicle alot data from response", response);

//         const updatedData =
//           response?.data?.map(
//             ({ id, vendor_id, vendor_name, status, ...rest }) => ({
//               id,
//               vendor_id,
//               vendor_name,
//               status,
//               ...rest,
//             })
//           ) || [];

//         setDrivers(updatedData);
//         // console.log(response.data);
//         setStatus(response?.status);

//         const finalData = response?.data?.map((item, index) => {
//           const tripDate =
//             Array.isArray(item.date_history) && item.date_history.length > 0
//               ? item.date_history
//                 .map(
//                   (rec) =>
//                     `${rec.va_start_date || "-"} to ${rec.va_end_date || "-"}`
//                 )
//                 .join("\n")
//               : item.date_history || "-";
//           const vendorName =
//             Array.isArray(item.driver_history) && item.driver_history.length > 0
//               ? item.driver_history
//                 .map((rec) => rec.company_name || "-")
//                 .join("\n")
//               : item.driver_history || "-";

//           const driverDetail =
//             Array.isArray(item.driver_history) && item.driver_history.length > 0
//               ? item.driver_history
//                 .map((rec) => rec.driver_name || "-")
//                 .join("\n")
//               : item.driver_history || "-";
//           const vehicleDetail =
//             Array.isArray(item.vehicle_history) &&
//               item.vehicle_history.length > 0
//               ? item.vehicle_history
//                 .map((rec) => rec.vehiclename || "-")
//                 .join("\n")
//               : item.vehicle_history || "-";
//           const remark =
//             Array.isArray(item.remark_history) && item.remark_history.length > 0
//               ? item.remark_history.map((rec) => rec.remark || "-").join("\n")
//               : item.remark_history || "-";

//           return {
//             "SI.No": index + 1,
//             "Booking Id": item.ref_no,
//             "Guest Name": item.client_name,
//             "Start Date": item.start_date,
//             "End Date": item.end_date,
//             "Vehicle Type": item.client_vehiclename,
//             "Trip Date": tripDate,
//             "Vendor Name": vendorName,
//             "Vehicle Detail": vehicleDetail,
//             "Driver Detail": driverDetail,
//             Remarks: remark,
//           };
//         });
//         // console.log("final data ", finalData);

//         setExportingData(finalData);
//       } catch (error) {
//         setError(true);
//         console.error("Error fetching drivers:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     if (!isUpdate && location.search && !searchstartDate && !searchendDate) {
//       // console.log("Skipping initial fetch — waiting for URL date parsing");
//       return;
//     }

//     fetchDrivers();
//     setIsUpdate(false);
//     // eslint-disable-next-line
//   }, [tab, isUpdate, searchstartDate, searchendDate]);

//   const handleTabChange = (event, newValue) => {
//     setTab(newValue);
//     setSearchEndDate(null);
//     setSearchStartDate(null);
//     setIsUpdate(true);
//   };

//   const handleSearch = () => {
//     setIsUpdate(true);
//   };

//   const handleRefresh = () => {
//     setSearchEndDate(null);
//     setSearchStartDate(null);
//     setIsUpdate(true);
//   };

//   const isAdmin = adminInfo?.id === 1;

//   const hideView = isAdmin
//     ? true
//     : adminInfo?.permission?.some(
//       (perm) => perm.id_tab === "vehicle allotment" && perm.view === 1
//     );

//   const hideAdd = isAdmin
//     ? true
//     : adminInfo?.permission?.some(
//       (perm) => perm.id_tab === "vehicle allotment" && perm.add === 1
//     );

//   const hideExport = isAdmin
//     ? true
//     : adminInfo?.permission?.some(
//       (perm) => perm.id_tab === "vehicle allotment" && perm.export === 1
//     );

//   const hideEdit = isAdmin
//     ? true
//     : adminInfo?.permission?.some(
//         (perm) => perm.id_tab === "vehicle allotment" && perm.edit === 1
//       );

//   const getTabName = () => {
//     if (tab === 0) return "UnAlloted";
//     if (tab === 1) return "Alloted";
//     if (tab === 2) return "All";
//     if (tab === 3) return "Cancelled";
//     return "";
//   };

//   return (
//     <>
//       {hideView && (
//         <>
//           <DeleteModal id={null} title="" />
//           <MainDrawer>
//             <VehicleAllotDrawer id={null} />
//           </MainDrawer>
//           <PageTitle sidebar={sidebar().sidebar} />
//           <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800">
//             <CardBody>
//               <div className="flex flex-wrap items-center gap-3">
//                 <div className="flex items-center gap-3">
//                   <div className="flex items-center gap-2">
//                     <LabelArea label="Start Date" />
//                     <div className="w-50">
//                       <InputSearchDate
//                         value={searchstartDate}
//                         onChange={(event) => setSearchStartDate(event)}
//                       />
//                     </div>
//                   </div>

//                   <div className="flex items-center gap-2">
//                     <LabelArea label="Between" />
//                     <div className="w-50">
//                       <InputSearchDate
//                         min={searchstartDate}
//                         value={searchendDate}
//                         onChange={(event) => setSearchEndDate(event)}
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 <div className="flex-1">
//                   <Input
//                     ref={vehicleAllotRef}
//                     className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
//                     type="search"
//                     name="search"
//                     autoComplete="off"
//                     placeholder="Quick Search"
//                     onChange={handleSubmitVehicleAllot}
//                   />
//                 </div>

//                 {hideExport && (
//                   <ExportDataXlsx
//                     title="Driver"
//                     exportDataXlsx={exportingData}
//                     fileNames={`Vehicle_${getTabName()}`}
//                     startDate={searchstartDate}
//                     endDate={searchendDate}
//                   />
//                 )}

//                 <Button
//                   className="rounded-md h-10 px-8"
//                   onClick={() => {
//                     handleSearch();
//                   }}
//                 >
//                   Search
//                 </Button>

//                 <FiRefreshCcw
//                   onClick={() => {
//                     handleRefresh();
//                   }}
//                   cursor="pointer"
//                 />
//               </div>
//             </CardBody>
//           </Card>
//           <Tabs
//             value={tab}
//             onChange={handleTabChange}
//             TabIndicatorProps={{
//               style: { backgroundColor: "#057a55" },
//             }}
//           >
//             {/* <Tab label="All" /> */}
//             <Tab
//               className="focus:outline-none dark:text-white"
//               sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
//               label={<span className="capitalize">UnAlloted</span>}
//             />
//             <Tab
//               className="focus:outline-none dark:text-white"
//               sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
//               label={<span className="capitalize">Alloted</span>}
//             />
//             <Tab
//               className="focus:outline-none dark:text-white"
//               sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
//               label={<span className="capitalize">All</span>}
//             />

//             <Tab
//               className="focus:outline-none dark:text-white"
//               sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
//               label={<span className="capitalize">Cancelled</span>}
//             />
//           </Tabs>
//           <DataWrapper loading={loading} error={error} status={status}>
//             {serviceData?.length ? (
//               <TableContainer>
//                 <div
//                   className="overflow-y-scroll"
//                   style={{ maxHeight: "67vh", scrollbarWidth: "thin" }}
//                 >
//                   <Table>
//                     <TableHeader className="custom-table-header capitalize z-10 text-center sticky top-0 text-sm">
//                       <tr>
//                         <TableCell>Sl.No.</TableCell>
//                         <TableCell>Booking Id</TableCell>
//                         <TableCell>Guest Name</TableCell>
//                         <TableCell>Travel Date</TableCell>

//                         {tab === 0 && <TableCell>Vehicle type</TableCell>}

//                         <TableCell>Trip Date</TableCell>

//                         <TableCell>Vendor Name</TableCell>
//                         <TableCell>Remarks</TableCell>
//                         {/* For tabs other than 0, show Vehicle Type after Trip Date */}
//                         {tab !== 0 && <TableCell>Vehicle Details</TableCell>}

//                         {tab !== 0 && <TableCell>Driver Detail</TableCell>}

//                         {tab !== 0 && tab !== 3 && (
//                           <TableCell className="text-center">
//                             Trip Status
//                           </TableCell>
//                         )}

//                         {tab !== 3 && hideEdit &&(
//                           <TableCell className="text-center">Actions</TableCell>
//                         )}
//                       </tr>
//                     </TableHeader>
//                     <VehicleAllotTable
//                       tab={tab}
//                       driver={dataTable}
//                       perpage={itemsPerPage}
//                       currentPage={currentPage}
//                       hideAdd={hideAdd}
//                       hideEdit={hideEdit}
//                     />
//                   </Table>
//                 </div>
//               </TableContainer>
//             ) : (
//               <>
//                 {status !== true ? (
//                   <Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
//                 ) : (
//                   <NotFound title="There are no Bookings." />
//                 )}
//               </>
//             )}
//           </DataWrapper>
//         </>
//       )}
//     </>
//   );
// };

// export default VehicleAllot;

import {
  Card,
  CardBody,
  Input,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";
import { useState, useEffect, useContext } from "react";
import { Tabs, Tab } from "@mui/material";
import { FiRefreshCcw } from "react-icons/fi";
import ExportDataXlsx from "components/common/ExportDataXlsx";
import DataWrapper from "./DataWrapper";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";
import useFilter from "hooks/useFilter";
import VehicleAllotServices from "services/VehicleAllotServices";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import { SidebarContext } from "context/SidebarContext";

import VehicleAllotTable from "components/driver/VehicleAllotTable";
import VehicleAllotDrawer from "components/drawer/VehicleAllotDrawer";
import LabelArea from "components/form/LabelArea";
import InputSearchDate from "components/form/InputSearchDate";
import sidebar from "routes/sidebar";
import Somethingwentwrong from "pages/Somethingwentwrong";
import { useLocation } from "react-router-dom";

const VehicleAllot = () => {
  const location = useLocation();
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tab, setTab] = useState(0); // Tab state
  const [error, setError] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const { setIsUpdate, isUpdate } = useContext(SidebarContext);
  const [status, setStatus] = useState(false);
  const [exportingData, setExportingData] = useState([]);

  // const { adminInfo } = state;
  const {
    vehicleAllotRef,
    dataTable,
    serviceData,
    handleSubmitVehicleAllot,
    currentPage,
  } = useFilter(drivers, itemsPerPage);

  useEffect(() => {
    if (serviceData.length !== 0) {
      setItemsPerPage(serviceData.length);
    }
  }, [serviceData]);
  const [searchstartDate, setSearchStartDate] = useState(null);
  const [searchendDate, setSearchEndDate] = useState(null);
  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const parseDDMMYYYY = (value) => {
    if (!value) return null;
    const [d, m, y] = value.split("-");
    const date = new Date(`${y}-${m}-${d}`);
    return isNaN(date.getTime()) ? null : date;
  };

  const formattedDates = {
    start_date: formatDate(searchstartDate),
    end_date: formatDate(searchendDate),
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const startStr = params.get("start");
    const endStr = params.get("end");

    const startDate = parseDDMMYYYY(startStr);
    const endDate = parseDDMMYYYY(endStr);

    let needsRefresh = false;

    if (startDate) {
      setSearchStartDate((prev) =>
        prev?.getTime() === startDate.getTime() ? prev : startDate,
      );
      needsRefresh = true;
    }

    if (endDate) {
      setSearchEndDate((prev) =>
        prev?.getTime() === endDate.getTime() ? prev : endDate,
      );
      needsRefresh = true;
    }

    if (needsRefresh) {
      setIsUpdate(true);
    }
  }, [location.search]);

  // Fetch data based on selected tab
  useEffect(() => {
    const fetchDrivers = async () => {
      setLoading(true);
      try {
        // is_seller is no longer sent from the client — the backend derives
        // the scoping condition from the authenticated employee's own profile.
        const response = await VehicleAllotServices.getVehicleAllotList({
          id_employee: adminInfo.id,
          type: tab + 1,
          from: formattedDates.start_date,
          to: formattedDates.end_date,
        });
        // console.log("vehicle alot data from response", response);

        const updatedData =
          response?.data?.map(
            ({ id, vendor_id, vendor_name, status, ...rest }) => ({
              id,
              vendor_id,
              vendor_name,
              status,
              ...rest,
            }),
          ) || [];

        setDrivers(updatedData);
        // console.log(response.data);
        setStatus(response?.status);

        const finalData = response?.data?.flatMap((item, index) => {
          const histories = item.allotment_history?.length
            ? item.allotment_history
            : [{}];

          return histories.map((history, historyIndex) => ({
            "SI.No": historyIndex === 0 ? index + 1 : "",
            "Booking Id": item.ref_no || "-",
            "Guest Name": item.client_name || "-",
            "Start Date": item.start_date || "-",
            "End Date": item.end_date || "-",
            "Vehicle Type": item.client_vehiclename || "-",
            "Franchise Name": history.franchise_name || "-",
            "Vendor Name": history.vendor_name || "-",
            "Trip Date":
              history.va_start_date && history.va_end_date
                ? `${history.va_start_date} to ${history.va_end_date}`
                : history.va_start_date || "-",
            "Vehicle Detail": history.vehicle_name
              ? `${history.vehicle_name} (${history.vehicle_reg_no || "-"})`
              : "-",
            "Driver Detail": history.driver_name
              ? `${history.driver_name} (${history.driver_number || "-"})`
              : "-",

            Remarks: history.reason || "-",
          }));
        });
        // console.log("final data ", finalData);

        setExportingData(finalData);
      } catch (error) {
        setError(true);
        console.error("Error fetching drivers:", error);
      } finally {
        setLoading(false);
      }
    };
    if (!isUpdate && location.search && !searchstartDate && !searchendDate) {
      // console.log("Skipping initial fetch — waiting for URL date parsing");
      return;
    }

    fetchDrivers();
    setIsUpdate(false);
    // eslint-disable-next-line
  }, [tab, isUpdate, searchstartDate, searchendDate]);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
    setSearchEndDate(null);
    setSearchStartDate(null);
    setIsUpdate(true);
  };

  const handleSearch = () => {
    setIsUpdate(true);
  };

  const handleRefresh = () => {
    setSearchEndDate(null);
    setSearchStartDate(null);
    setIsUpdate(true);
  };

  const isAdmin = adminInfo?.id === 1;

  const hideView = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "vehicle allotment" && perm.view === 1,
      );

  const hideAdd = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "vehicle allotment" && perm.add === 1,
      );

  const hideExport = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "vehicle allotment" && perm.export === 1,
      );

  const hideEdit = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "vehicle allotment" && perm.edit === 1,
      );

  const getTabName = () => {
    if (tab === 0) return "UnAlloted";
    if (tab === 1) return "Alloted";
    if (tab === 2) return "All";
    if (tab === 3) return "Cancelled";
    return "";
  };

  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={null} title="" />
          <MainDrawer>
            <VehicleAllotDrawer id={null} />
          </MainDrawer>
          <PageTitle sidebar={sidebar().sidebar} />
          <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800">
            <CardBody>
              <div className="flex flex-wrap items-center gap-3">
                <div className="flex items-center gap-3">
                  <div className="flex items-center gap-2">
                    <LabelArea label="Start Date" />
                    <div className="w-50">
                      <InputSearchDate
                        value={searchstartDate}
                        onChange={(event) => setSearchStartDate(event)}
                      />
                    </div>
                  </div>

                  <div className="flex items-center gap-2">
                    <LabelArea label="Between" />
                    <div className="w-50">
                      <InputSearchDate
                        min={searchstartDate}
                        value={searchendDate}
                        onChange={(event) => setSearchEndDate(event)}
                      />
                    </div>
                  </div>
                </div>

                <div className="flex-1">
                  <Input
                    ref={vehicleAllotRef}
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    name="search"
                    autoComplete="off"
                    placeholder="Quick Search"
                    onChange={handleSubmitVehicleAllot}
                  />
                </div>

                {hideExport && (
                  <ExportDataXlsx
                    title="Driver"
                    exportDataXlsx={exportingData}
                    fileNames={`Vehicle_${getTabName()}`}
                    startDate={searchstartDate}
                    endDate={searchendDate}
                  />
                )}

                <Button
                  className="rounded-md h-10 px-8"
                  onClick={() => {
                    handleSearch();
                  }}
                >
                  Search
                </Button>

                <FiRefreshCcw
                  onClick={() => {
                    handleRefresh();
                  }}
                  cursor="pointer"
                />
              </div>
            </CardBody>
          </Card>
          <Tabs
            value={tab}
            onChange={handleTabChange}
            TabIndicatorProps={{
              style: { backgroundColor: "#057a55" },
            }}
          >
            {/* <Tab label="All" /> */}
            <Tab
              className="focus:outline-none dark:text-white"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label={<span className="capitalize">UnAlloted</span>}
            />
            <Tab
              className="focus:outline-none dark:text-white"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label={<span className="capitalize">Alloted</span>}
            />
            <Tab
              className="focus:outline-none dark:text-white"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label={<span className="capitalize">All</span>}
            />

            <Tab
              className="focus:outline-none dark:text-white"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label={<span className="capitalize">Cancelled</span>}
            />
          </Tabs>
          <DataWrapper loading={loading} error={error} status={status}>
            {serviceData?.length ? (
              <TableContainer>
                <div
                  className="overflow-y-scroll"
                  style={{ maxHeight: "67vh", scrollbarWidth: "thin" }}
                >
                  <Table>
                    <TableHeader className="custom-table-header capitalize z-10 text-center sticky top-0 text-sm">
                      <tr>
                        <TableCell>Sl.No.</TableCell>
                        <TableCell>Booking Id</TableCell>
                        <TableCell>Guest Name</TableCell>
                        <TableCell>Start/End City</TableCell>
                        <TableCell>Travel Date</TableCell>
                        <TableCell>Tour Type</TableCell>

                        {tab === 0 && <TableCell>Vehicle type</TableCell>}

                        <TableCell>Franchise Name</TableCell>
                        <TableCell>Vendor Name</TableCell>

                        <TableCell>Vehicle Details</TableCell>
                        <TableCell>Driver Name</TableCell>
                        <TableCell>Trip Date</TableCell>
                        <TableCell>Remarks</TableCell>
                        <TableCell>Trip Status</TableCell>

                        {/* {(tab === 1 ||tab===2 )&& (<TableCell>update Trip Status</TableCell>)} */}

                        {tab !== 3 && hideEdit && (
                          <TableCell className="text-center">Actions</TableCell>
                        )}
                      </tr>
                    </TableHeader>
                    <VehicleAllotTable
                      tab={tab}
                      driver={dataTable}
                      perpage={itemsPerPage}
                      currentPage={currentPage}
                      hideAdd={hideAdd}
                      hideEdit={hideEdit}
                      setIsUpdate={setIsUpdate}
                    />
                  </Table>
                </div>
              </TableContainer>
            ) : (
              <>
                {status !== true ? (
                  <Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
                ) : (
                  <NotFound title="There are no Bookings." />
                )}
              </>
            )}
          </DataWrapper>
        </>
      )}
    </>
  );
};

export default VehicleAllot;
